import React, {Suspense, useEffect, useLayoutEffect} from "react";
import {matchPath, Redirect, Route, Switch, useHistory, useLocation} from "react-router";

import {isGoogleTagManagerInitialized} from "@pg-mono/google-tag-manager";
import {kmAppLink, kmAppPath, SiteSlug} from "@pg-mono/km-routes";
import {parseSearch} from "@pg-mono/request";

import {FullPageLoader} from "../../../components/loaders/FullPageLoader";
import {useAppDispatch} from "../../../store/hooks/use_app_dispatch";
import {useAppSelector} from "../../../store/hooks/use_app_selector";
import {setRedirectPath} from "../../auth/state/auth_slice";
import {readRedirectPath, saveRedirectPath} from "../../auth/utils/redirect_path_storage";
import {CplUnsubscribeView} from "../../mailing/views/CplUnsubscribeView";
import {HomeMatchUnsubscribeView} from "../../mailing/views/HomeMatchUnsubscribeView";
import {MailingUnsubscribeView} from "../../mailing/views/MailingUnsubscribeView";
import {useGetUserProfileQuery} from "../../user/api/user_api";
import {fetchVariables} from "../api/fetch_variables";
import {AuthenticatedLayout} from "../layouts/AuthenticatedLayout";
import {setVariables} from "../state/variables_slice";

const UnauthenticatedRoutes = React.lazy(() => import("./UnauthenticatedRoutes"));
const AuthenticatedRoutes = React.lazy(() => import("./AuthenticatedRoutes"));

export const AuthenticationRouting = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const location = useLocation();
    const allowAuthenticatedRoutes = useAppSelector((state) => state.auth.allowAuthenticatedRoutes);

    const {data, isLoading, isUninitialized} = useGetUserProfileQuery();
    const profileFetchFinished = !isUninitialized && !isLoading;
    const isProfilePending = isUninitialized || isLoading;
    const isAuthenticatedAppPath = Boolean(
        matchPath(location.pathname, {path: kmAppPath.site.dashboard.base}) ||
        matchPath(location.pathname, {path: kmAppPath.site.offers.base}) ||
        matchPath(location.pathname, {path: kmAppPath.site.messages.base}) ||
        matchPath(location.pathname, {path: kmAppPath.site.user.base})
    );

    useEffect(() => {
        const {next: redirectPath} = parseSearch(location.search);

        if (redirectPath && typeof redirectPath === "string") {
            dispatch(setRedirectPath(redirectPath));
            saveRedirectPath(redirectPath);

            // Keep `next` in the URL until GTM consumes the promoted top-level params (`_gl`, `cookieConsent`).
            // Removing it too early would strip those params before GTM finishes initializing.
            const hasGtmManagedParams = ["_gl=", "cookieConsent="].some((param) => location.search.includes(param));

            if (hasGtmManagedParams && !isGoogleTagManagerInitialized()) {
                return;
            }

            const searchParams = new URLSearchParams(location.search);
            searchParams.delete("next");
            history.replace({
                pathname: location.pathname,
                search: searchParams.toString() ? `?${searchParams.toString()}` : ""
            });
        } else {
            const storedRedirectPath = readRedirectPath();

            if (storedRedirectPath) {
                dispatch(setRedirectPath(storedRedirectPath));
            }
        }
    }, [dispatch, history, location.pathname, location.search]);

    useEffect(() => {
        fetchVariables().then((res) => dispatch(setVariables(res.data)));
    }, []);

    useLayoutEffect(() => {
        if (!isAuthenticatedAppPath) return;

        const root = document.documentElement;
        const previous = root.style.scrollbarGutter;
        root.style.scrollbarGutter = "stable";

        return () => {
            root.style.scrollbarGutter = previous;
        };
    }, [isAuthenticatedAppPath]);

    const isAuthenticated = Boolean(data && allowAuthenticatedRoutes);
    const hasSiteInPath = Boolean(matchPath(location.pathname, {path: kmAppPath.site.base}));

    if (isProfilePending && isAuthenticatedAppPath) return <FullPageLoader inChrome />;

    if (isProfilePending) return <FullPageLoader />;

    if (isAuthenticated && !hasSiteInPath) return <Redirect to={kmAppLink.site.baseWithParams({site: SiteSlug.KM})} />;

    return (
        <Switch>
            <Route path="/:url*" exact strict render={(props) => <Redirect to={`${props.location.pathname}/`} />} />
            {/* Routes for both authenticated and unauthenticated users */}
            <Route path={kmAppPath.site.unsubscribe.cpl} exact component={CplUnsubscribeView} />
            {profileFetchFinished && <Route path={kmAppPath.site.unsubscribe.mailing} exact component={() => <MailingUnsubscribeView userProfile={data} />} />}
            <Route path={kmAppPath.unsubscribeHM} exact component={HomeMatchUnsubscribeView} />

            {isAuthenticated ? (
                <AuthenticatedLayout>
                    <Suspense fallback={<FullPageLoader inChrome />}>
                        <AuthenticatedRoutes />
                    </Suspense>
                </AuthenticatedLayout>
            ) : (
                <Suspense fallback={<FullPageLoader />}>
                    <UnauthenticatedRoutes />
                </Suspense>
            )}
        </Switch>
    );
};
import React, {Suspense, useEffect, useLayoutEffect} from "react";
import {matchPath, Redirect, Route, Switch, useHistory, useLocation} from "react-router";

import {isGoogleTagManagerInitialized} from "@pg-mono/google-tag-manager";
import {kmAppLink, kmAppPath, SiteSlug} from "@pg-mono/km-routes";
import {parseSearch} from "@pg-mono/request";

import {FullPageLoader} from "../../../components/loaders/FullPageLoader";
import {useAppDispatch} from "../../../store/hooks/use_app_dispatch";
import {useAppSelector} from "../../../store/hooks/use_app_selector";
import {setRedirectPath} from "../../auth/state/auth_slice";
import {readRedirectPath, saveRedirectPath} from "../../auth/utils/redirect_path_storage";
import {CplUnsubscribeView} from "../../mailing/views/CplUnsubscribeView";
import {HomeMatchUnsubscribeView} from "../../mailing/views/HomeMatchUnsubscribeView";
import {MailingUnsubscribeView} from "../../mailing/views/MailingUnsubscribeView";
import {useGetUserProfileQuery} from "../../user/api/user_api";
import {fetchVariables} from "../api/fetch_variables";
import {AuthenticatedLayout} from "../layouts/AuthenticatedLayout";
import {setVariables} from "../state/variables_slice";

const UnauthenticatedRoutes = React.lazy(() => import("./UnauthenticatedRoutes"));
const AuthenticatedRoutes = React.lazy(() => import("./AuthenticatedRoutes"));

export const AuthenticationRouting = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const location = useLocation();
    const allowAuthenticatedRoutes = useAppSelector((state) => state.auth.allowAuthenticatedRoutes);

    const {data, isLoading, isUninitialized} = useGetUserProfileQuery();
    const profileFetchFinished = !isUninitialized && !isLoading;
    const isProfilePending = isUninitialized || isLoading;
    const isAuthenticatedAppPath = Boolean(
        matchPath(location.pathname, {path: kmAppPath.site.dashboard.base}) ||
        matchPath(location.pathname, {path: kmAppPath.site.offers.base}) ||
        matchPath(location.pathname, {path: kmAppPath.site.messages.base}) ||
        matchPath(location.pathname, {path: kmAppPath.site.user.base})
    );

    useEffect(() => {
        const {next: redirectPath} = parseSearch(location.search);

        if (redirectPath && typeof redirectPath === "string") {
            dispatch(setRedirectPath(redirectPath));
            saveRedirectPath(redirectPath);

            // Keep `next` in the URL until GTM consumes the promoted top-level params (`_gl`, `cookieConsent`).
            // Removing it too early would strip those params before GTM finishes initializing.
            const hasGtmManagedParams = ["_gl=", "cookieConsent="].some((param) => location.search.includes(param));

            if (hasGtmManagedParams && !isGoogleTagManagerInitialized()) {
                return;
            }

            const searchParams = new URLSearchParams(location.search);
            searchParams.delete("next");
            history.replace({
                pathname: location.pathname,
                search: searchParams.toString() ? `?${searchParams.toString()}` : ""
            });
        } else {
            const storedRedirectPath = readRedirectPath();

            if (storedRedirectPath) {
                dispatch(setRedirectPath(storedRedirectPath));
            }
        }
    }, [dispatch, history, location.pathname, location.search]);

    useEffect(() => {
        fetchVariables().then((res) => dispatch(setVariables(res.data)));
    }, []);

    useLayoutEffect(() => {
        if (!isAuthenticatedAppPath) return;

        const root = document.documentElement;
        const previous = root.style.scrollbarGutter;
        root.style.scrollbarGutter = "stable";

        return () => {
            root.style.scrollbarGutter = previous;
        };
    }, [isAuthenticatedAppPath]);

    const isAuthenticated = Boolean(data && allowAuthenticatedRoutes);
    const hasSiteInPath = Boolean(matchPath(location.pathname, {path: kmAppPath.site.base}));

    if (isProfilePending && isAuthenticatedAppPath) return <FullPageLoader inChrome />;

    if (isProfilePending) return <FullPageLoader />;

    if (isAuthenticated && !hasSiteInPath) return <Redirect to={kmAppLink.site.baseWithParams({site: SiteSlug.KM})} />;

    return (
        <Switch>
            <Route path="/:url*" exact strict render={(props) => <Redirect to={`${props.location.pathname}/`} />} />
            {/* Routes for both authenticated and unauthenticated users */}
            <Route path={kmAppPath.site.unsubscribe.cpl} exact component={CplUnsubscribeView} />
            {profileFetchFinished && <Route path={kmAppPath.site.unsubscribe.mailing} exact component={() => <MailingUnsubscribeView userProfile={data} />} />}
            <Route path={kmAppPath.unsubscribeHM} exact component={HomeMatchUnsubscribeView} />

            {isAuthenticated ? (
                <AuthenticatedLayout>
                    <Suspense fallback={<FullPageLoader inChrome />}>
                        <AuthenticatedRoutes />
                    </Suspense>
                </AuthenticatedLayout>
            ) : (
                <Suspense fallback={<FullPageLoader />}>
                    <UnauthenticatedRoutes />
                </Suspense>
            )}
        </Switch>
    );
};
